import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { Grid, Typography } from '@oresundsbron/bridge-ui';
import { useTranslation } from 'next-i18next';
import { InfoSkeleton } from './InfoSkeleton';
import { InfoItem } from './InfoItem';

export const QueueTimeInformation = () => {
  const { t } = useTranslation(['bridgeStatus', 'common'], {
    nsMode: 'fallback',
  });

  const { data: queueTime, isLoading } = useTypeSafeQuery(
    BackendQueryKeys.QueueTime(),
    (req) => req.BridgeStatus.queueTime(),
    {
      retry: 2,
      refetchInterval: 30 * 1000, // poll interval 30 sec
      refetchIntervalInBackground: true,
    }
  );
  return (
    <div className="col-start-2">
      {isLoading ? (
        <InfoSkeleton />
      ) : (
        <Grid>
          <Typography
            as="h3"
            intent="title"
            size="lg"
            className="col-span-full"
          >
            {t('bridgeStatus.queueTime.heading')}
          </Typography>

          <InfoItem
            titleKey={'bridgeStatus.queueTime.labels.towardsSweden'}
            value={
              queueTime?.towardsSweden?.value != null
                ? `${Math.floor(queueTime.towardsSweden.value)} ${t(
                    'bridgeStatus.queueTime.timeUnit'
                  )}`
                : '-'
            }
          />
          <InfoItem
            titleKey={'bridgeStatus.queueTime.labels.towardsDenmark'}
            value={
              queueTime?.towardsDenmark?.value != null
                ? `${Math.floor(queueTime.towardsDenmark.value)} ${t(
                    'bridgeStatus.queueTime.timeUnit'
                  )}`
                : '-'
            }
          />
        </Grid>
      )}
    </div>
  );
};
